/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Max_Duration_LabelInputs */



/**
* | output |
* | --- |
* | "Maximum Event Duration (in seconds)" |
*
* @param {Style_Guide_Manager_Max_Duration_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_max_duration_label = /** @type {((inputs?: Style_Guide_Manager_Max_Duration_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Max_Duration_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Duree maximale d'evenement (en secondes)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Maximale Ereignisdauer (in Sekunden)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Durata massima dell'evento (in secondi)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Максимальная продолжительность события (в секундах)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Duración máxima del evento (en segundos)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("事件最大持续时间（秒）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("最大イベント継続時間（秒）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अधिकतम इवेंट अवधि (सेकंड में)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Duração máxima do evento (em segundos)")
	return /** @type {LocalizedString} */ ("Maximum Event Duration (in seconds)")
});